module.exports = __webpack_public_path__ + "static/media/IMG_20180302_195748.d865bb03.jpg";